var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-5" }, [
    _c(
      "div",
      { staticClass: "bg-white" },
      [
        _c(
          "el-table",
          {
            attrs: { data: _vm.list, stripe: "", "highlight-current-row": "" },
          },
          [
            _c("el-table-column", {
              attrs: { label: "名称" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " + _vm._s(scope.row.name) + "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "链接" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.deviceType >= 0
                        ? _c("div", [
                            _vm._v("二维码：" + _vm._s(scope.row.link)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      scope.row.deviceType >= 0
                        ? _c("div", { staticClass: "mt-10" }, [
                            _vm._v(
                              "小程序：" +
                                _vm._s(_vm.xcx_page[scope.row.deviceType])
                            ),
                          ])
                        : _c("div", [_vm._v(_vm._s(scope.row.link))]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "操作" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            round: "",
                            plain: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.copyLink(scope.row)
                            },
                          },
                        },
                        [_vm._v("复制链接")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pt-20 fs-s4" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("upload", {
              attrs: { uploadText: "上传校验文件", raw: true },
              on: { getFile: _vm.getFile },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-15" }, [
      _vm._v(
        "\n        温馨提示：扫二维码进入小程序需要登录微信、支付宝小程序添加普通二维码跳转小程序规则。添加方法："
      ),
      _c(
        "a",
        {
          staticClass: "text-blue",
          attrs: {
            href: "https://developers.weixin.qq.com/miniprogram/introduction/qrcode.html#%E9%85%8D%E7%BD%AE%E6%B5%81%E7%A8%8B",
            target: "_blank",
          },
        },
        [_vm._v("微信")]
      ),
      _vm._v("、"),
      _c(
        "a",
        {
          staticClass: "text-blue",
          attrs: {
            href: "https://opendocs.alipay.com/mini/operation/vzd5v0",
            target: "_blank",
          },
        },
        [_vm._v("支付宝")]
      ),
      _vm._v("。需要上传校验文件时，下载文件后点击下面上传校验文件。\n      "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }